import React from 'react';
import './index.scss'
import {openKf} from '../../../Utils/Utils'

export default function FollowTips(props) {
  return (<div className={"FollowTips" + (props.big ? ' big' : '')}>
    <p onClick={()=>{
      openKf()
    }}>如您有任何疑问，可咨询酷狗在线客服：<span className="blue">点击联系</span></p>
  </div>)
}